/*
 * ===============================================================================================================
 *                                Copyright 2020, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { SHOW_ERROR } from './types';

const initialState = {
    error: {}
}

export const errorReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SHOW_ERROR:
            return {
                ...state,
                error: action.error
            }
        default:
            return state;
    }
}